import React, { Component } from 'react';
import Slider from 'react-slick';

import properties from '../../../modules/ajio-util/properties';
const imageBaseUrl = properties.getProperty('imageBaseUrl');
class ProductPromoOffers extends Component {
  constructor(props) {
    super(props);
    this.textResources = {
      moreOffers: 'more offers',
      applied: 'Applied',
      nonApplied: 'Not Applicable',
      offers: 'Offers',
      viewproducts: 'View Products',
      addproducts: 'Add Products',
      alreadyAtBestPrice: 'Product already at best price'
    };
    this.listedVoucherCount = 0;
  }

  render() {
    const { offers = {} } = this.props;

    return (
      <div className="offer-wrapper">
        {this._renderSwipeOffers()}
        {this._renderMoreOffer()}
      </div>
    );
  }

  _renderSwipeOffers() {
    const { offers = {}, listVoucher = 0, isPageTitle = '' } = this.props;

    this.listedVoucherCount = 0;
    const slickSettings = {
      arrows: true,
      swipe: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2
    };
    const { appliedVouchers = [], potentialPromotion = {}, appliedPromotion = {} } = offers;
    const offersLength = appliedVouchers
      .concat(Object.keys(potentialPromotion))
      .concat(Object.keys(appliedPromotion)).length;
    return (
      <div className="alloffers-wrapper">
        {isPageTitle ? (
          <div className="offers-slider-wrapper">
            {appliedVouchers.length > 0 && (
              <div className="applied-voucher">
                {offers.hasOwnProperty('appliedVouchers')
                  ? this._showVoucher(offers.appliedVouchers)
                  : ''}
              </div>
            )}
            {Object.keys(appliedPromotion).length > 0 && (
              <div className="applied-promotion">
                {offers.hasOwnProperty('appliedPromotion')
                  ? this._showPromotion(offers.appliedPromotion, 'applied')
                  : ''}
              </div>
            )}

            {Object.keys(potentialPromotion).length > 2 ? (
              <Slider {...slickSettings} ref="slick">
                {offers.hasOwnProperty('potentialPromotion')
                  ? this._showPromotion(offers.potentialPromotion, 'potential')
                  : ''}
              </Slider>
            ) : (
              <div
                className={`offers-no-slider ${
                  Object.keys(potentialPromotion).length === 1 ? 'single-offer' : 'multi-offer'
                }`}
              >
                {offers.hasOwnProperty('potentialPromotion')
                  ? this._showPromotion(offers.potentialPromotion, 'potential')
                  : ''}
              </div>
            )}
          </div>
        ) : (
          <div className="offers-slider-wrapper">
            {offersLength > 3 ? (
              <Slider {...slickSettings} ref="slick">
                {offers.hasOwnProperty('appliedVouchers')
                  ? this._showVoucher(offers.appliedVouchers)
                  : ''}
                {offers.hasOwnProperty('appliedPromotion')
                  ? this._showPromotion(offers.appliedPromotion, 'applied')
                  : ''}
                {offers.hasOwnProperty('potentialPromotion')
                  ? this._showPromotion(offers.potentialPromotion, 'potential')
                  : ''}
              </Slider>
            ) : (
              <div
                className={`offers-no-slider ${
                  offersLength === 1 ? 'single-offer' : 'multi-offer'
                }`}
              >
                {offers.hasOwnProperty('appliedVouchers')
                  ? this._showVoucher(offers.appliedVouchers)
                  : ''}
                {offers.hasOwnProperty('appliedPromotion')
                  ? this._showPromotion(offers.appliedPromotion, 'applied')
                  : ''}
                {offers.hasOwnProperty('potentialPromotion')
                  ? this._showPromotion(offers.potentialPromotion, 'potential')
                  : ''}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  _showVoucher(appliedVouchers = []) {
    const { voucherCode = '' } = appliedVouchers[0];
    const {
      voucherMessages = '',
      priceInfo: { couponSaving: { value: couponSavingValue } = {} } = {}
    } = this.props;
    this.listedVoucherCount = 1;

    return (
      <section className="promo-offer" key="voucher">
        <p className="voucher-label">{voucherCode}</p>
        <span className={voucherMessages == 'Applied' ? 'applied' : 'non-applied'}>
          {voucherMessages == 'Applied'
            ? this.textResources.applied
            : this.textResources.nonApplied}
        </span>
      </section>
    );
  }

  _showPromotion(promotionObject = {}, promotionType) {
    const {
      listVoucher = 0,
      priceInfo: { promoSaving: { value: promoSavingValue } = {} } = {},
      appliedPromoFiredMsg = ''
    } = this.props;
    let { tier = [], nontier = [] } = promotionObject;

    tier = tier.filter((item, index) => {
      const { promotion: { code = '' } = {} } = item;
      if (code.indexOf(code) == index) {
        return item;
      }
    });

    let returnPromotionHtml = '';
    if (tier.length && listVoucher !== this.listedVoucherCount) {
      returnPromotionHtml = [];
      for (let iter = 0; iter < tier.length; iter++) {
        if (this.listedVoucherCount == listVoucher) {
          break;
        }
        const { description = '', promotion: { detailsURL = '', code = '' } = {} } = tier[iter];

        this.listedVoucherCount++;
        returnPromotionHtml.push(
          <section className="promo-offer" key={`${promotionType} - ${iter}`}>
            <p className="voucher-label">{description}</p>
            {promotionType !== 'applied' ? (
              <a className="add-product-from-cart" href={detailsURL}>
                {this.textResources.addproducts}
              </a>
            ) : (
              ''
            )}
            {promotionType === 'applied' ? (
              <span className="applied">{this.textResources.applied}</span>
            ) : (
              ''
            )}
            {promotionType === 'applied' && appliedPromoFiredMsg ? (
              <span className="best-price-msg">{appliedPromoFiredMsg}</span>
            ) : null}
          </section>
        );
      }
    }

    if (this.listedVoucherCount === 0 && nontier.length) {
      const {
        promotion: { description = '', detailsURL = '' }
      } = nontier[0];

      returnPromotionHtml = (
        <section className="promo-offer" key="singlePromotion">
          <p className="voucher-label">{description}</p>
          <a href={detailsURL}>{this.textResources.viewproducts}</a>
          {promotionType === 'applied' ? (
            <span className="applied">{this.textResources.applied}</span>
          ) : (
            ''
          )}
        </section>
      );
    }
    return returnPromotionHtml;
  }

  _renderMoreOffer() {
    const { offers = {}, listVoucher = 0 } = this.props;
    let {
      appliedVouchers = [],
      potentialPromotion: { tier: potentialTier = [], nontier: potentialNonTier = [] } = {},
      appliedPromotion: { tier: appliedTier = [], nontier: appliedNonTier = [] } = {}
    } = offers;

    appliedTier = appliedTier.filter((item, index) => {
      const { promotion: { code = '' } = {} } = item;
      if (code.indexOf(code) == index) {
        return item;
      }
    });

    const offersCount = appliedVouchers
      .concat(potentialTier)
      .concat(potentialNonTier)
      .concat(appliedTier)
      .concat(appliedNonTier).length;
    let moreOfferHtml = '';

    if (offersCount > listVoucher) {
      moreOfferHtml = (
        <div
          className="more-offer-button"
          onClick={() => {
            this.props.setModal({
              name: 'promo-offer',
              classes: 'promo-offer-modal',
              content: this._showOfferPopUp()
            });
          }}
        >
          {this.textResources.moreOffers}
        </div>
      );
    }
    return moreOfferHtml;
  }

  _showOfferPopUp() {
    const { offers = {} } = this.props;
    let {
      appliedVouchers = [],
      potentialPromotion: { tier: potentialTier = [], nontier: potentialNonTier = [] } = {},
      appliedPromotion: { tier: appliedTier = [], nontier: appliedNonTier = [] } = {}
    } = offers;

    appliedTier = appliedTier.filter((item, index) => {
      const { promotion: { code = '' } = {} } = item;
      if (code.indexOf(code) == index) {
        return item;
      }
    });

    const offersArray = appliedVouchers
      .concat(potentialTier)
      .concat(potentialNonTier)
      .concat(appliedTier)
      .concat(appliedNonTier);

    return (
      <div id="promoOfferModal">
        <p className="offer-header" id="offerHeader"  style={{
          backgroundImage: `url(${`${imageBaseUrl}/static/img/offers_image.png`})`
         }}>
          {this.textResources.offers}
        </p>
        {offersArray.length > 0 ? (
          <ul className="offer-list-wrapper">
            {appliedVouchers.map((item, key) => {
              const { voucherCode = '' } = item;
              return this._getOfferListItem({
                label: voucherCode,
                applied: true,
                key
              });
            })}
            {appliedTier.map((item, key) => {
              const { promotion: { detailsURL = '', code = '' } = {}, description = '' } = item;
              return this._getOfferListItem({
                label: description,
                applied: true,
                key,
                multiItemPromo: true
                // code
              });
            })}
            {appliedNonTier.map((item, key) => {
              const { promotion: { detailsURL = '', code = '' } = {}, description = '' } = item;
              return this._getOfferListItem({
                label: description,
                applied: true,
                key,
                code
              });
            })}
            {potentialTier.map((item, key) => {
              const { promotion: { detailsURL = '', code = '' } = {}, description = '' } = item;
              return this._getOfferListItem({
                label: description,
                applied: false,
                addProduct: true,
                url: detailsURL,
                key
                // code
              });
            })}
            {potentialNonTier.map((item, key) => {
              const { promotion: { detailsURL = '', code = '' } = {}, description = '' } = item;
              return this._getOfferListItem({
                label: description,
                applied: false,
                addProduct: false,
                url: detailsURL,
                key,
                code
              });
            })}
          </ul>
        ) : (
          ''
        )}
      </div>
    );
  }

  _getOfferListItem(options) {
    const { label = '', applied = true, key, code = '', multiItemPromo = false } = options;
    const { voucherMessages = '' } = this.props;

    return (
      <div key={key}>
        {applied ? (
          <span
            className={voucherMessages == 'Applied' || multiItemPromo ? 'applied' : 'non-applied'}
          >
            {voucherMessages == 'Applied' || multiItemPromo
              ? this.textResources.applied
              : this.textResources.nonApplied}
          </span>
        ) : (
          ''
        )}
        <li>
          <span className="voucher">{label}</span>
          {options.hasOwnProperty('addProduct') ? (
            <a href={options.url}>
              {options.addProduct
                ? this.textResources.addproducts
                : this.textResources.viewproducts}
            </a>
          ) : (
            ''
          )}
          {code != '' ? <span className="promotion-code">{code}</span> : ''}
        </li>
      </div>
    );
  }
}

export default ProductPromoOffers;
